import { React, useEffect, useState, axios, decryptData, Header, Link, useNavigate, SideNav, Chevron, InfoIcon, handleApiError, CustomModal, SuccessfullVector, InfoVector, FormatDate, useLocation, AlertInfo } from "../../MentorImport";
import "./GradeAssignment.css";

const GradeAssignment = () => {
  const [selectedBatches, setSelectedBatches] = useState(JSON.parse(sessionStorage.getItem("Batches")) || []);
  const [ratingData, setRatingData] = useState({
    tableData: [],
    isRowEditable: false,
    isModalOpen: false,
    modalType: "",
    modalTitle: "",
    modalMessage: "",
    icon: null,
    cancelText: "",
    confirmText: "",
  });

  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const { id, firstName, lastName, submissionDate, assignmentLink, hostedLink, gradingParameters } = userDetails ?? {};
  const [updatedGradingParameters, setUpdatedGradingParameters] = useState(ratingData.tableData.gradingParameters);

  const navigate = useNavigate();
  const location = useLocation();
  const ratingArray = ["Not Acceptable", "Needs Improvement", "Meets Requirement", "Exceeds Expectations"];
  const data = localStorage.getItem("userData");
  let parsedObject;
  data ? (parsedObject = decryptData(data, process.env.REACT_APP_USER_KEY)) : navigate("/error/statusCode=400");
  const cancelToken = axios.CancelToken.source();

  const fetchData = async () => {
    let apiUrl = `${process.env.REACT_APP_API_URL_DOTNET}/Review/getUserCourseAssignmentReviewDetails?userReviewId=${id}`;
    const headers = {
      Authorization: `Bearer ${parsedObject["token"]}`,
      cancelToken: cancelToken.token,
    };
    try {
      const response = await axios.get(apiUrl, { headers });
      if (response.data.success === 200) {
        setRatingData((prevState) => ({
          ...prevState,
          tableData: response.data.result,
          isRowEditable: !response.data.result.isSubmitted,
        }));
        setUpdatedGradingParameters(response.data.result.gradingParameters)
        // gradingParameters = response.data.result.gradingParameters;
      } else {
        throw new Error(`Unexpected response status: ${response.data.success}`);
      }
    } catch (error) {
      const statusCode = error.response ? error.response : null;
      handleApiError(statusCode, navigate);
    }
  };

  function getInitials(name) {
    const names = name.split(" ");
    const initials = names?.map((n) => n.charAt(0).toUpperCase());
    return initials.join("");
  }

  const isDataValid = () => {
    if (!ratingData.isRowEditable) return true;
    else if (updatedGradingParameters?.every((param) => param.value !== 0)) return false;
    else return true;
  };

    const handleRadioChange = (paramIndex, value) => {
      if (ratingData.isRowEditable) {
        setUpdatedGradingParameters((prevState) =>
          prevState.map((param, index) => (index === paramIndex ? { ...param, value } : param))
        );
      }
    };

  const sendRatedData = async () => {
    // const editedRowData = ratingData.tableData;
    const reviewData = {
      id: id,
      gradingParameters: updatedGradingParameters,
    };
    const formData = new FormData();
    formData.append("reviewData", JSON.stringify(reviewData));

    try {
      const response = await axios.post(process.env.REACT_APP_API_URL_DOTNET + `/Review/submitUserCourseAssignmentReview`, formData, {
        headers: { Authorization: `Bearer ${parsedObject["token"]}`, "Content-Type": "multipart/form-data" },
        cancelToken: cancelToken.token,
      });
      if (response.data.success === 200) {
        fetchData();
        // gradingParameters = response.data.result.gradingParameters;
        setRatingData((prevData) => ({
          ...prevData,
          isModalOpen: true,
          modalType: "success",
          modalTitle: response.data.message,
          modalMessage: "",
          icon: <SuccessfullVector />,
          cancelText: "",
          confirmText: "",
        }));
      } else {
        setRatingData((prevData) => ({
          ...prevData,
          isModalOpen: true,
          modalType: "error",
          modalTitle: "Error!",
          modalMessage: response.data.message,
          icon: <AlertInfo />,
        }));
      }
    } catch (error) {
      console.error("This is error in report:", error);
    }
  };
  const gradingSource = gradingParameters?.every((param) => param.value !== 0) ? gradingParameters : updatedGradingParameters;
      // const gradingSource = updatedGradingParameters;
  const handleClose = () => {
    setRatingData((prevData) => ({
      ...prevData,
      isModalOpen: false,
      modalType: "",
      modalTitle: "",
      modalMessage: "",
      icon: null,
    }));
  };

  const fullName = (firstName || "") + " " + (lastName || "");
  const initials = getInitials(fullName);

  useEffect(() => {
    fetchData();
    return () => {
      cancelToken.cancel("request cancelled");
    };
  }, [selectedBatches]);

  useEffect(() => {
    const handleRouteChange = () => {
      sessionStorage.removeItem("userDetails");
    };
    return () => {
      handleRouteChange();
    };
  }, [location.pathname]);

  return (
    <div>
      <div style={{ marginBottom: "5rem" }}>
        <Header selectedBatches={selectedBatches} setSelectedBatches={setSelectedBatches} />
        <SideNav />
      </div>
      <div className="grade-assignment-parent-wrapper">
        <div className="grade-assignment-breadChrum">
          <Link to="/lms/grade-assignment" className="crumb-parent">
            Grade Assignment
          </Link>
          <Chevron />
          <span>Review Assignment Submission</span>
        </div>
        <div className="grade-assignment-data-wrapper">
          <div className="grade-assignment-heading-style">
            <h3>Review Assignment Submission</h3>
          </div>
          <div className="grade-assignment-table-box-style">
            <div className="row">
              <div className="frame">
                <p className="d-flex justify-content-center align-items-center m-0 grade-assignment-initials">{initials}</p>
              </div>
              <div className="d-flex align-items-center col-4">
                <div className="frame-text grade-assignment-name">{fullName}</div>
              </div>
            </div>
            <div className="grade-assignment-border">
              <div className="d-grid gap-2">
                <div className="d-flex justify-content-between">
                  <div className="grade-assignment-link-name">
                    Assignment Link:
                    <a href={assignmentLink} className="grade-assignment-link pointer ms-2">
                      {assignmentLink?.length < 50 ? assignmentLink : assignmentLink?.slice(0, 50).concat("...")}
                    </a>
                  </div>
                  <div className="grade-assignment-submission">
                    Submission Date: <span className="grade-assignment-submission-date">{FormatDate(submissionDate)}</span>
                  </div>
                </div>
                <div className="grade-assignment-link-name">
                  Hosted Link:
                  {hostedLink === null || hostedLink === "" ? (
                    <span className="ms-2 grade-assignment-no-link">NA</span>
                  ) : (
                    <a href={hostedLink} className="grade-assignment-link pointer ms-2">
                      {hostedLink?.length < 50 ? hostedLink : hostedLink?.slice(0, 50).concat("...")}
                    </a>
                  )}
                </div>
              </div>
            </div>
            <div className="grade-assignment-table-description-style">
              <div className="desc-child-one">
                <InfoIcon />
              </div>
              <div className="grade-assignment-desc-child-two">
                <p className="mb-0 fw-bold">Please rate assignment submission in each area using the following guidelines:</p>
                <div className="grade-assignment-rate-info-wrapper">
                  {ratingArray?.map((rateVal, rateInd) => {
                    return (
                      <div className="desc-value-wrapper">
                        <span className="fw-bold">{`${rateInd + 1}`}</span> &nbsp;
                        <span>{`- ${rateVal}`}</span>
                      </div>
                    );
                  })}
                </div>
              </div>
            </div>
            <div className="table-container-parent-wrapper">
              <div className="grade-assignment-table-container">
                <table className="grade-assignment-custom-table w-100">
                  <thead>
                    <tr>
                      <th className="text-center">BASIS</th>
                      <th>1</th>
                      <th>2</th>
                      <th>3</th>
                      <th>4</th>
                    </tr>
                  </thead>
                  <tbody>
                    {gradingSource?.map((param, index) => (
                      <tr key={param.name}>
                        <td className="text-start overflow-hidden text-break">{param.name.toUpperCase()}</td>
                        {ratingArray.map((_, rateInd) => (
                          <td className="pointer" key={rateInd} onClick={() => handleRadioChange(index, rateInd + 1)}>
                            <input
                              className="form-check-input grade-radio-input"
                              type="radio"
                              name={param.name}
                              value={rateInd + 1}
                              checked={param.value === rateInd + 1}
                              onChange={() => handleRadioChange(index, rateInd + 1)}
                              disabled={!ratingData.isRowEditable || isDataValid()}  // Ensure this is correct
                            />
                          </td>
                        ))}
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
            <div className="grade-assignment-save-button-wrapper" style={{ alignSelf: "end" }}>
              <button
                onClick={() => {
                  setRatingData((prevData) => ({
                    ...prevData,
                    isModalOpen: true,
                    modalType: "confirm",
                    modalTitle: "Are You Sure?",
                    modalMessage: "Do you want to save these grades? This process cannot be undone.",
                    icon: <InfoVector />,
                    cancelText: "No, Cancel",
                    confirmText: "Yes, Sure",
                  }));
                }}
                disabled={isDataValid()}
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>
      {ratingData.isModalOpen && (
        <CustomModal
          modalProps={{
            icon: ratingData.icon,
            show: ratingData.isModalOpen,
            type: ratingData.modalType,
            title: ratingData.modalTitle,
            message: ratingData.modalMessage,
            onCancel: handleClose,
            onConfirm: sendRatedData,
            cancelText: ratingData.cancelText,
            confirmText: ratingData.confirmText,
          }}
        />
      )}
    </div>
  );
};

export default GradeAssignment;
